import React from 'react';

function isActive(startDate, endDate) {
	if (startDate) {
		var dateObj = new Date();

		var month = dateObj.getUTCMonth() + 1; month = month < 10 ? '0' + month : '' + month;
		var day = dateObj.getUTCDate(); day = day < 10 ? '0' + day : '' + day;
		var year = dateObj.getUTCFullYear();
		var now = year+"-"+month+"-"+day;

		var status = "up";
		
		if (endDate) {
			// has end date
			if (now < startDate && now < endDate) {
				status = "paused";
			} else if (now > startDate && now > endDate) {
				status = "down";
			}
		} else {
			// no end date supplied
			if (now < startDate) {
				status = "paused";
			} else if (now > startDate) {
				status = "up";
			}
		}

	} else {
		status = "noDate";
	}
	
	return status;
}


export class ResultList extends React.Component {
	loadProfile(id) {
		this.props.resetProfile();
		setTimeout(() => {
			this.props.load(id);
		}, 50);
	}

	render() {
		let data = this.props.data;
		let page = this.props.page;
		return (
			<ul className="result-list" id={page+"-list"} >
				
				{(data && (page === "client")) && (
					data.map(client => 
						<li key={client.clientCode} className={
								"cc-"+client.clientCode+
								" status-"+ client.status +
								" velocity-"+client.velocity +
								" servicePackage-"+client.servicePackage +
								" franchise-"+client.franchiseName
								}>
							<button onClick={() => this.loadProfile(client.clientCode)} className="client-button" >
								<strong>{client.name}</strong>
								<p><small>Nickname (cde): {client.nickname}</small></p>
								<p><small>Client Code: {client.clientCode}</small></p>
								<p><small>Account Manager: {client.manager}</small></p>
								<p className={"velocity-"+client.velocity}><small>Velocity {client.servicePackage}</small></p>
							</button>
						</li>
					)
				)}
				{(data && (page === "vpl")) && (
					data.map(client => 
						<li key={client.siteId} className="all">
							<button onClick={() => this.props.load(client.clientCode)} className="client-button">
								<strong>{client.name}</strong>
								<p><small>Domain: {client.domain}</small></p>
							</button>
						</li>
					)
				)}

				{(data && (page === "promotions")) && (
					data.map(promo =>
						<li key={promo.promoId} className={"all "+promo.promoCode+" "+isActive(promo.startDate, promo.endDate)}>
							<span className={"stat_bar "+isActive(promo.startDate, promo.endDate)}></span>
							
							<button onClick={() => this.props.load(promo.promoId)} className="client-button">
								<strong>{promo.name}</strong>
								<p><small>Start: {promo.startDate}</small></p>
								<p><small>End: {promo.endDate}</small></p>
							</button>
						</li>
					)
				)}

				{(data && (page === "ecampaigns")) && (
					data.map(promo =>
						<li key={promo.promoId} className={"all "+promo.promoCode}>
							<button onClick={() => this.props.load(promo.promoId)} className="client-button">
								<strong>{promo.name}</strong>
							</button>
						</li>
					)
				)}

				{(data && (page === "blogs")) && (
					data.map(blog => 
						<li key={blog.blogId} className={"all "+isActive(blog.startDate, blog.endDate)}>
							<span className={"stat_bar "+isActive(blog.startDate, blog.endDate)}></span>
							<button onClick={() => this.props.load(blog.blogId)} className="client-button">
								<strong>{blog.name}</strong>
								<p><small>Start: {blog.startDate}</small></p>
								{(blog.endDate) && (
									<p><small>End: {blog.endDate}</small></p>
								)}
							</button>
						</li>
					)
				)}

				{(data && (page === "flooring-you-well" || page === "emser")) && (
					data.map((dealer, index) =>
						<li key={index} className={dealer.dealerId +" ret all "+dealer.participant} >
							<span className={"stat_bar up stat-"+dealer.participant}></span>
							<button onClick={() => this.props.load(dealer.retailerCode)} className="client-button">
								{dealer.name}
								<p className="dealer-ids">Dealer ID(s): {dealer.locations.map((details, index) => (index === 0) ?
										( <React.Fragment key={index}>
											<span>{details.locationCode}</span>
										</React.Fragment>) :
										( <React.Fragment key={index}>
											<span>{", "+details.locationCode}</span>
										</React.Fragment> )
									)}
								</p>
							</button>
						</li>
					)
				)}

				{(data && (page === "nfa")) && (
					data.map((client, index) => 
						<li key={index} className="all">
							<button onClick={() => this.loadProfile(client.retailerCode)} className="client-button">
								<strong>{client.name}</strong>
							</button>
						</li>
					)
				)}

			</ul>

		)
	}

}


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/ResultList.js